export const overlay = {
  overlay: {
    select: {
      background: 'var(--p-surface-0)',
      borderColor: 'var(--p-surface-border)',
      color: 'var(--p-text-color)',
    },
    popover: {
      background: 'var(--p-surface-0)',
      borderColor: 'var(--p-surface-border)',
      color: 'var(--p-text-color)',
    },
    modal: {
      background: 'var(--p-surface-0)',
      borderColor: 'var(--p-surface-border)',
      color: 'var(--p-text-color)',
    },
  },
};
